<template>
    <div class="row">
        <div class="col-6 mb-1">
            <label class="form-label">Ad</label>
            <v-validator :errors="errors" parameter="FirstName" :watch="value.FirstName">
                <input type="text" class="form-control" :disabled="value.EmployeeId != null" placeholder="Ad" v-model="value.FirstName"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Soyad</label>
            <v-validator :errors="errors" parameter="LastName" :watch="value.LastName">
                <input type="text" class="form-control" :disabled="value.EmployeeId != null" placeholder="Soyad" v-model="value.LastName"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">E-Posta</label>
            <v-validator :errors="errors" parameter="Email" :watch="value.Email">
                <input type="text" class="form-control" :disabled="value.EmployeeId != null" placeholder="E-Posta" v-model="value.Email"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Rol</label>
            <v-validator :errors="errors" parameter="RoleGroupId" :watch="role">
                <v-select-list v-model="role" label="Name" placeholder="Rol" :options="roles"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <v-validator :errors="errors" parameter="Description" :watch="value.Description">
                <input type="text" class="form-control" placeholder="Açıklama" v-model="value.Description"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-validator :errors="errors" parameter="EmployeeDepartmentTitleId" :watch="employee">
                <v-select-list v-model="employee" :options="employees" label="Combine" v-on:search="searchEmployees" placeholder="Personel" :loading="employeeLoading"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Plasiyer Kodu</label>
            <v-validator :errors="errors" parameter="PlasiyerCode" :watch="value.PlasiyerCode">
                <input type="text" class="form-control" placeholder="Açıklama" v-model="value.PlasiyerCode"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <b-form-checkbox disabled v-model="value.ActiveStatus" name="ssl-cb">Aktiflik Durumu</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import SystemDefinitionsApi from '@/api/system-definitions'
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean
    },
    data(){
        return{
            roles:[],
            employeeLoading:false,
            employees:[],
        }
    },
    mounted(){
        if (this.value.EmployeeFullName) {
            this.searchEmployees(this.value.EmployeeFullName);
        }
        this.getRoles();
    },
    methods:{
        getRoles(){
            SystemDefinitionsApi.Role.List()
            .then(res=>{
                this.roles = res.data.Data
            })
        },
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
    },
    computed:{
        role:{
            get:function(){
                return this.roles.find(b=>b.Id==this.value.RoleGroupId)
            },
            set:function(value){
                this.value.RoleGroupId = value?.Id || this.value.RoleGroupId
            }
        },
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
    }



}
</script>


<style lang="scss">
</style>